import {AbstractService} from 'services/AbstractService';
import omit from 'lodash.omit';
import googleanalyticsIcon from 'assets/webanalyticsproviders/googleanalytics.svg';
import yandexmetrikaIcon from 'assets/webanalyticsproviders/yandexmetrika.svg';
import amocrmIcon from 'assets/webanalyticsproviders/amocrm.svg';
import comagicIcon from 'assets/webanalyticsproviders/comagic.svg';
import customIcon from 'assets/webanalyticsproviders/custom.svg';
import appmetricaIcon from 'assets/webanalyticsproviders/appmetrica.svg';

const PROFILES_LIST_URL = '/api/projects/{0}/webanalytics/profiles';
const ACCOUNT_PROFILES_LIST_URL = '/api/webanalytics/profiles';
const PROFILE_DETAILS_URL = '/api/webanalytics/profiles/{0}';
const PROFILE_GOALS_LIST_URL = '/api/webanalytics/profiles/{0}/goals';

const GOALS_LIST_URL = '/api/projects/{0}/webanalytics/goals';
const ACCOUNT_GOALS_LIST_URL = '/api/webanalytics/goals';

const WA_CHANNELS_LIST = '/api/webanalytics/providers';


const channelIconMap = {
  googleanalytics: googleanalyticsIcon,
  yandexmetrika: yandexmetrikaIcon,
  amocrm: amocrmIcon,
  comagic: comagicIcon,
  custom: customIcon,
  appmetrica: appmetricaIcon
};

export class WebanalyticsService extends AbstractService {
  getIconByChannelName (providerName) {
    return channelIconMap[providerName];
  }

  removeProfilePostprocessing (profile) {
    return omit(profile, ['provider', 'icon', 'formattedName']);
  }

  async getChannels () {
    return (await this.client.get(WA_CHANNELS_LIST)).items;
  }

  async getAccountProfilesList ({accountId, accountIds}) {
    return (await this.client.get(ACCOUNT_PROFILES_LIST_URL, {account_id: accountIds}, accountId)).items;
  }

  async getProfilesList (accountId, projectId, {sorting} = {}) {
    return (await this.client.get(PROFILES_LIST_URL.format(projectId), {sorting}, {accountId})).items;
  }

  async getProfile ({accountId, profileId}) {
    return await this.client.get(PROFILE_DETAILS_URL.format(profileId), {}, accountId);
  }

  async saveProfileInfo (accountId, profileId, profile) {
    const filteredProfile = this.removeProfilePostprocessing(profile);

    await this.client.put(PROFILE_DETAILS_URL.format(profileId), filteredProfile, {accountId});
  }

  async getProfileGoals ({accountId, profileId}) {
    return (await this.client.get(PROFILE_GOALS_LIST_URL.format(profileId), {}, {accountId})).items;
  }

  async getAccountGoalsList ({accountId, accountIds}) {
    return (await this.client.get(ACCOUNT_GOALS_LIST_URL, {account_id: accountIds}, accountId)).items;
  }

  async getGoalsList (accountId, projectId) {
    return (await this.client.get(GOALS_LIST_URL.format(projectId), {}, {accountId})).items;
  }

  createProfile (accountId, projectId, connectionId, providerId, {enabled, xid, name, params}) {
    return this.client.post(ACCOUNT_PROFILES_LIST_URL, {
      connection_id: connectionId,
      project_id: projectId,
      provider_id: providerId,
      enabled,
      name,
      xid,
      params
    },
    {accountId}
    );
  }
}
